






















































import Vue from 'vue';
export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      agree: false,
    };
  },

  computed: {
    show: {
      get(): boolean {
        return this.value;
      },

      set(val: boolean) {
        this.$emit('input', val);
      },
    },

    supportsServiceWorkers(): boolean {
      return 'serviceWorker' in navigator;
    },

    userAgent() {
      return navigator.userAgent;
    },

    os() {
      var userAgent = navigator.userAgent || navigator.vendor;

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone';
      }

      if (/android/i.test(userAgent)) {
        return 'Android';
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
      }

      return 'unknown';
    },
  },
});
